import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum} from 'qcc'
import {appEnum} from 'utils/appEnum'

export default class RoleFormPage extends React.PureComponent<AppFormPageProps> {
    state = {}
    
	render() {
		let {formData,mode,id} = this.props;
		return (<AppFormLayout defaultButton mode={this.props.mode}>
            <AppFormLayout.Form>
                <AppForm entity='app_role' 
                loadingData={false} 
                mode={mode} 
                keyValue={id} 
                formData={formData} 
                afterSave={()=>{this.props.afterSave && this.props.afterSave()}}
                >
                    <AppForm.Section labelWidth={100}>
						<AppForm.Item itemType={AppFormItemEnum.hidden} field='is_admin' dataType={appEnum.dataType.number} />
                        <AppForm.Item field='name' itemType={AppFormItemEnum.input} label="角色名称" req unRepeat />
						<AppForm.Item field='remarks' itemType={AppFormItemEnum.text} label="描述"/>
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/application/role/EditForm.tsx